import { memo } from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  enabled: boolean
}

function SamlStatusTag({ enabled }: Props) {
  return (
    <Tag type={enabled ? 'viridian' : 'grey'}>
      {enabled
        ? i18n.t('settings.edit_company.saml_sso.active')
        : i18n.t('settings.edit_company.saml_sso.deactivated')}
    </Tag>
  )
}

export default memo(SamlStatusTag)
